import { AdminUser } from 'models/adminUser';

import { Reset } from './generic';

export const LOAD_ADMIN_USER_LIST = 'LOAD_ADMIN_USER_LIST';
export const LOAD_ALL_USERS_AND_INVITEDS_LIST = 'LOAD_ALL_USERS_AND_INVITEDS_LIST';
export const LOAD_ALL_USERS = 'LOAD_ALL_USERS';
export const CREATE_USER = 'CREATE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const CREATE_USER_INVITE = 'CREATE_USER_INVITE';

export interface LoadAdminUserList {
  type: typeof LOAD_ADMIN_USER_LIST;
  adminUserList: AdminUser[];
}

export interface LoadAllUsers {
  type: typeof LOAD_ALL_USERS;
  allUsers: AdminUser[];
}

export interface CreateUser {
  type: typeof CREATE_USER;
  user: AdminUser;
}

export interface UpdateUser {
  type: typeof UPDATE_USER;
  user: AdminUser;
}

export interface CreateUserInvite {
  type: typeof CREATE_USER_INVITE;
  user: AdminUser;
}

export type AdminUserActions = LoadAdminUserList | CreateUser | UpdateUser | CreateUserInvite | LoadAllUsers | Reset;

export const doLoadAdminUserList = (adminUserList: AdminUser[]): AdminUserActions => ({
  type: LOAD_ADMIN_USER_LIST,
  adminUserList,
});

export const doLoadAllUserList = (allUsers: AdminUser[]): AdminUserActions => ({
  type: LOAD_ALL_USERS,
  allUsers,
});

export const doCreateUser = (user: AdminUser): AdminUserActions => ({
  type: CREATE_USER,
  user,
});

export const doUpdateUser = (user: AdminUser): AdminUserActions => ({
  type: UPDATE_USER,
  user,
});

export const doCreateInviteUser = (user: AdminUser): AdminUserActions => ({
  type: CREATE_USER_INVITE,
  user,
});
